module.exports = __webpack_public_path__ + "static/media/BLM2020ProtestNumbers.b23452c7.jpg";